import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { spec, validators } from 'utils/validation'
import { withFormModel } from 'shared/hooks'
import { StoreContext } from 'store/context'

import RequestFormComponent from './component'

const { string, any } = validators

export default combine(
  withContext('appStore', StoreContext),

  withFormModel(
    {
      email: spec.flow(
        string.isString,
        string.isEmail,
        string.isNotEmpty,
        any.required
      ),
    },
    { id: 'request-form' }
  ),

  withCallbacks(
    {
      onSubmitForm:
        (_state, { onSubmit }) =>
        (entity) =>
          onSubmit(entity),
    },
    []
  )
)(RequestFormComponent)
